import { useContext } from 'react';

import { LayersContext } from 'contexts/LayersContext';

export const useLayers = () => {
  const context = useContext(LayersContext);

  return context;
};
